// extracted by mini-css-extract-plugin
module.exports = {"nav600":"(min-width: 600px)","navShowDesktop":"(min-width: 900px )","navLg":"(min-width: 1158px )","bentosMultipleColumns":"950px"};